import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M2 8a4 4 0 0 1 4 -4h12a4 4 0 0 1 4 4v8a4 4 0 0 1 -4 4h-12a4 4 0 0 1 -4 -4v-8","key":"svg-0"}],["path",{"d":"M10 9l5 3l-5 3l0 -6","key":"svg-1"}]]

const IconBrandYoutube = createReactComponent('outline', 'brand-youtube', 'BrandYoutube', __iconNode);

export default IconBrandYoutube;